import React from 'react';
import cN from 'classnames';
import { Tag } from '@lion-design/core';
import * as Icons from '@components/Common/Icons';
import './styles.scss';

interface I_Parameters {
    text: string;
    isActive?: boolean;
    isHalfRadius?: boolean;
    isClosable?: boolean;
    tripType?: string;
    onClick?: any;
    onClose?: any;
    className?: string;
}

function appendIcon({ text, isActive, tripType = '' }: I_Parameters) {
    const iconFill = isActive ? '#fff' : '#222';

    switch (tripType) {
        case '01':
            return (
                <>
                    <Icons.Cruise fill={iconFill} />
                    {text}
                </>
            );
        case '02':
            return (
                <>
                    <Icons.Bus fill={iconFill} />
                    {text}
                </>
            );
        case '03':
            return (
                <>
                    <Icons.Train fill={iconFill} />
                    {text}
                </>
            );
        case '04':
            return (
                <>
                    <Icons.AirPlane fill={iconFill} />
                    {text}
                </>
            );
        default:
            return text;
    }
}

function appendFeaturedIcon({ text }: I_Parameters) {
    switch (text) {
        case '會員限購':
            return (
                <>
                    <Icons.Vip fill="#fff" />
                    <span className="slash" />
                    {text}
                </>
            );
        case '郵輪優先選房號':
            return (
                <>
                    <Icons.Cruise fill="#fff" />
                    <span className="slash" />
                    {text}
                </>
            );
        case '雄獅推薦':
            return (
                <>
                    <Icons.Lion fill="#fff" />
                    <span className="slash" />
                    {text}
                </>
            );
        default:
            return text;
    }
}

export const Normal: React.FC<I_Parameters> = (params) => (
    <Tag className={cN('normal', params.className)} onClick={params.onClick}>
        {appendIcon(params)}
    </Tag>
);
export const Selectable: React.FC<I_Parameters> = (params) => (
    <Tag
        className={cN('selectable', { active: params.isActive })}
        closable={params.isClosable || false}
        onClose={params.onClose}
    >
        {appendIcon(params)}
    </Tag>
);
export const Featured: React.FC<I_Parameters> = (params) => {
    let featuredClass = '';

    switch (params.text) {
        case '會員限購':
            featuredClass = 'vip';
            break;
        case '郵輪優先選房號':
            featuredClass = 'cruise';
            break;
        case '雄獅推薦':
            featuredClass = 'lion';
            break;
    }

    return (
        <Tag className={cN('featured', featuredClass, { halfRaidus: params.isHalfRadius })}>
            {appendFeaturedIcon(params)}
        </Tag>
    );
};
